import { Modal, Typography, message } from 'antd';
import { Customer } from '@/libs/fleet-api/services/customer';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { extendCustomerExpiry } from '@/libs/fleet-api/services/admin';
import { useState } from 'react';

export type ExtendExpiryModalData = {
	customer: Customer;
};

export const useExtendExpiryModal = () => {
	const [modalState, setModalState] = useState<{
		isOpen: boolean;
		data?: ExtendExpiryModalData;
	}>({ isOpen: false });

	return {
		modal: modalState,
		open: (data: ExtendExpiryModalData) =>
			setModalState({ isOpen: true, data }),
		close: () => setModalState({ isOpen: false }),
		data: modalState.data,
	};
};

export default function ExtendExpiryModal({
	modal,
	data,
	onClose,
}: {
	modal: ReturnType<typeof useExtendExpiryModal>['modal'];
	data?: ExtendExpiryModalData;
	onClose: () => void;
}) {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: extendCustomerExpiry,
		onSuccess: () => {
			message.success('Berhasil memperpanjang expiry date customer');
			queryClient.invalidateQueries({ queryKey: ['getAdminCustomers'] });
			onClose();
		},
		onError: (error: Error) => {
			message.error(error?.message || 'Gagal memperpanjang expiry date');
		},
	});

	const handleOk = () => {
		if (!data?.customer?.customerId) return;
		mutation.mutate({ customerId: data.customer.customerId });
	};

	return (
		<Modal
			title="Extend Customer Expiry"
			open={modal.isOpen}
			onOk={handleOk}
			onCancel={onClose}
			confirmLoading={mutation.isPending}
			okText="Yes"
			cancelText="No"
		>
			<Typography.Text>
				Are you sure you want to extend this customer's expire date?
				<br />
				<strong>Customer Name:</strong> {data?.customer?.customerName}
				<br />
				<strong>Customer ID:</strong> {data?.customer?.customerId}
			</Typography.Text>
		</Modal>
	);
}
